import React from "react";

import API from "@beardeddevops/react.api";
import Framework from '@beardeddevops/react.framework';
import Types from "constants/Types";
import TransactionCollection from "components/TransactionCollection";
import TransactionType from "../../constants/TransactionTypes";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

export default class Losses extends TransactionCollection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_LOSSES';
		this.model.set = TransactionType.Loss;
	}

	render() {
		const {loading} = this.state;
		return (
			<Card>
				<CardContent>
					{super.render('Losses', 'losses', "", [
						{
							Header: 'Notes',
							accessor: 'notes',
							show: !!this.state['column_notes'],
							toggle: 'column_notes'
						},
						{
							Header: 'Incident Number',
							id: 'transaction_collections.incident_number',
							accessor: object => {
								/** @type {Transactions_Collections_Object} object*/
								return object.transaction_collections.incident_number;
							},
						}
					])}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}